import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {ChangelogService} from './changelog.service';
import {Changelog} from './changelog';
import {from} from 'rxjs';
import {MessageService} from 'primeng/api';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {catchError} from 'rxjs/operators';

@Component({
    selector: 'app-changelog',
    standalone: true,
    imports: [CommonModule, SharedModule, DropdownModule, FormsModule],
    templateUrl: './changelog.component.html',
    styleUrls: ['./changelog.component.scss'],
    providers: [MessageService],
})
export class ChangelogComponent implements OnInit {
    changelogs: Changelog[] = [];
    futureFunctions: Changelog[] = [];
    allChangelogs: Changelog[] = [];
    pageLoading: boolean = true;
    filterOptions: { label: string, value: number | null }[] = [
        { label: 'All Changes', value: null },
        { label: 'Recent Changes', value: 1 },
        { label: 'Upcoming Features', value: 2 }
    ];
    selectedFilter: { label: string, value: number | null } = this.filterOptions[0];

    constructor(
        private changelogService: ChangelogService,
        private messageService: MessageService
    ) {}

    ngOnInit(): void {
        this.loadAllChangelogs();
    }

    private loadAllChangelogs(): void {
        this.pageLoading = true;
        this.changelogService.getAllChangelogs().pipe(
            catchError(error => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load changelogs. Please try again later.',
                    life: 5000,
                });
                return from([[]])
            })
        ).subscribe(changelogs => {
            this.allChangelogs = changelogs;
            this.filterChangelogs();
            this.pageLoading = false;
        });
    }

    filterChangelogs(): void {
        if (this.selectedFilter.value === null) {
            // Show all changelogs when "All Changes" is selected
            this.changelogs = this.allChangelogs.filter(log => log.area === 1)
                .sort((a, b) => (b.date || '').localeCompare(a.date || ''));
            this.futureFunctions = this.allChangelogs.filter(log => log.area === 2)
                .sort((a, b) => (b.date || '').localeCompare(a.date || ''));
        } else {
            // Filter by selected area
            const filtered = this.allChangelogs.filter(log => log.area === this.selectedFilter.value)
                .sort((a, b) => (b.date || '').localeCompare(a.date || ''));

            if (this.selectedFilter.value === 1) {
                this.changelogs = filtered;
                this.futureFunctions = [];
            } else {
                this.changelogs = [];
                this.futureFunctions = filtered;
            }
        }
    }

    onFilterChange(): void {
        this.filterChangelogs();
    }

}
